export enum DatatablePaging {
  /**
   * The ordering and search will be recalculated and the rows redrawn in their new positions.
   * The paging will not be reset - i.e. the current page will still be shown.
   */
  FULL_HOLD = 'full-hold',

  /**
   *  The ordering and search will be recalculated and the rows redrawn in their new positions.
   *  The paging will be reset back to the first page.
   */
  FULL_RESET = 'full-reset',

  /**
   * Ordering and search will not be updated and the paging position held where is was.
   * This is useful for paging (i.e. page()) when data has not been changed between draws.
   */
  PAGE = 'page',
}
